import { render, staticRenderFns } from "./revenue-cost.vue?vue&type=template&id=1b705406&scoped=true"
import script from "./revenue-cost.vue?vue&type=script&lang=js"
export * from "./revenue-cost.vue?vue&type=script&lang=js"
import style0 from "./revenue-cost.vue?vue&type=style&index=0&id=1b705406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b705406",
  null
  
)

export default component.exports